import React from "react";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { Button, TextField, Box } from "@mui/material";
import { STRINGS, SIZES, VARIANTS, BUTTON_COLORS, AUTO_COMPLETE } from "../../../common/constants/commonConstants.js";
import { CUSTOMER_STRINGS, CUSTOMER_KEYS, CUSTOMER_MESSAGES } from "../../../common/constants/customerModule/customerConstants.js";
import DialogComponent from "../../../common/components/DialogComponent.jsx";

const AddEditCustomerDialog = ({
    campaigns,
    onSave,
    open,
    selectedCustomer,
    handleInputChange,
    onClose,
}) => {
    return (
        <>
            <DialogComponent
                open={open}
                setWidth="xs"
                onClose={onClose}
                title={selectedCustomer?.id ? CUSTOMER_STRINGS.EDIT_CUSTOMER : CUSTOMER_STRINGS.ADD_CUSTOMER}
                actions={
                    <Button
                        onClick={onSave}
                        variant={VARIANTS.CONTAINED}
                        color={BUTTON_COLORS.PRIMARY}
                    >
                        {STRINGS.SAVE}
                    </Button>
                }
            >
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    <TextField
                        fullWidth
                        size={SIZES.SMALL}
                        autoComplete={AUTO_COMPLETE.OFF}
                        label={CUSTOMER_STRINGS.FIRST_NAME}
                        value={selectedCustomer?.firstname || ""}
                        onChange={handleInputChange(CUSTOMER_KEYS.FIRST_NAME)}
                    />
                    <TextField
                        fullWidth
                        size={SIZES.SMALL}
                        autoComplete={AUTO_COMPLETE.OFF}
                        label={CUSTOMER_STRINGS.LAST_NAME}
                        value={selectedCustomer?.lastname || ""}
                        onChange={handleInputChange(CUSTOMER_KEYS.LAST_NAME)}
                    />
                    <TextField
                        fullWidth
                        size={SIZES.SMALL}
                        autoComplete={AUTO_COMPLETE.OFF}
                        label={CUSTOMER_STRINGS.EMAIL}
                        value={selectedCustomer?.emailaddress || ""}
                        onChange={handleInputChange(CUSTOMER_KEYS.EMAIL)}
                    />
                    <TextField
                        fullWidth
                        size={SIZES.SMALL}
                        autoComplete={AUTO_COMPLETE.OFF}
                        label={CUSTOMER_STRINGS.PHONE_NUMBER}
                        value={selectedCustomer?.customeruniqueid || ""}
                        onChange={handleInputChange(CUSTOMER_KEYS.PHONE_NUMBER)}
                    />
                    <FormControl
                        fullWidth
                        size={SIZES.SMALL}
                    >
                        <InputLabel id="campaign-select-label">{CUSTOMER_STRINGS.CAMPAIGN}</InputLabel>
                        <Select
                            labelId="campaign-select-label"
                            id="campaign-select"
                            label={CUSTOMER_STRINGS.CAMPAIGN}
                            value={selectedCustomer?.campaignid || ""}
                            onChange={handleInputChange(CUSTOMER_KEYS.CAMPAIGN_ID)}
                        >
                            {campaigns?.length > 0 ? (
                                campaigns.map((campaign) => (
                                    <MenuItem key={campaign.id} value={campaign.id}>
                                        {campaign.name}
                                    </MenuItem>
                                ))
                            ) : (
                                <MenuItem disabled>{CUSTOMER_MESSAGES.NO_CAMPAIGNS}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                </Box>
            </DialogComponent>
        </>
    )
};

export default AddEditCustomerDialog;